import React from 'react';
import styled from 'styled-components';

const VideoWrapper = styled.div`
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
    background-color: black;
`

const VideoIFrame = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

export const Video = () =>
<div className="row justify-content-center">
    <div className="col-12 col-lg-11 col-xl-10">
        <VideoWrapper>
            <VideoIFrame title="YouTube video of The Greening Variations" width="560" height="315" src="https://www.youtube.com/embed/kTXngs2SZm0" frameBorder="0" allow="encrypted-media" allowFullScreen>
            </VideoIFrame>
        </VideoWrapper>
    </div>
</div>
